import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a42a1b5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "todos-count-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!

  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["footer__button-todo", { 'is-active': _ctx.isActive }]),
    tabindex: 0,
    onMousedown: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onAction && _ctx.onAction(...args)), ["stop"]))
  }, [
    _createVNode(_component_BaseSubHeading, {
      size: "large",
      weight: "500",
      color: "monochrome-06"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" ToDo ")
      ]),
      _: 1
    }),
    (_ctx.count > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_BaseSubHeading, {
            size: "small",
            weight: "600",
            color: "monochrome-00",
            class: "todos-count-container__text"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.count > 99 ? "99+" : _ctx.count), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 34))
}